import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../pages/Dashboard';
import Review from '../pages/Review';
import ReviewAvailableDomainsSettings from '../pages/ReviewAvailableDomainsSettings';
import ReviewSettingsWrapper from '../pages/ReviewSettingsWrapper';
import ReviewWrapper from '../pages/ReviewWrapper';
import PageNotFound from '../pages/error-pages/PageNotFound';
import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/review',
      name: 'ReviewWrapper',
      component: ReviewWrapper,
      redirect: { name: 'Review' },
      children: [
        {
          path: 'approval',
          name: 'Review',
          component: Review,
        },
      ],
    },
    {
      path: '/review-settings',
      name: 'ReviewSettingsWrapper',
      component: ReviewSettingsWrapper,
      redirect: { name: 'ReviewAvailableDomainsSettings' },
      children: [
        {
          path: 'available-domains',
          name: 'ReviewAvailableDomainsSettings',
          component: ReviewAvailableDomainsSettings,
        },
      ],
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js